export default {
  mounted() {
    this.listFunctions();
  },
  methods: {
    /**
     *
     * 根据 roleId，menuUrl 获取功能菜单的统一方法
     * @returns
     */
    listFunctions() {
      const { featureList } = this.$store.getters;
      this.functionList = featureList.map(item => item.menuId);
    },
  },
};
